import { render, staticRenderFns } from "./IconSunHorizon.vue?vue&type=template&id=12d6cc4d&"
import script from "./IconSunHorizon.vue?vue&type=script&lang=js&"
export * from "./IconSunHorizon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports